import { clearHelperState, getWebsiteInfo } from '@/actions/helperAction';
import { addRoomDiscussion, editRoomDiscussion } from '@/actions/room';
import {
  CustomDiscussionTextArea,
} from '@/components/common/CustomTextArea';
import { NewLinkPreview } from '@/components/common/LinkPreview';
import LinkPreviewLoader from '@/components/common/LinkPreview/Loader';
import AvatarComponent from '@/components/common/avatar';
import DiscussionPoll from '@/components/landing/room/components/discussion-poll';
import {
  capitalizeFirstLetter,
  isLinkPresent,
  isObjEmpty,
  removeImageKeyFromObj,
} from '@/helpers/dataHelper';
import FormDataHelper from '@/helpers/formDataHelper';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Form, Modal, Upload } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const DiscussionModal = ({
  roomId,
  discussionId,
  postFile,
  visible,
  onCancel,
  title,
  form,
  setPostFile,
  loading,
  editData,
  formType,
  pollItems,
  setPollItems,
  createPoll,
  setCreatePoll,
  createPostPoll = false,
  isPostImage = false,
  setCreatePostPoll,
  setIsPostImage,
  roomTitle,
}) => {
  const windowSize = typeof window !== 'undefined' && useRef(window.innerWidth);
  const dispatch = useDispatch();
  const [postData, setPostData] = useState(editData?.text || '');

  useEffect(() => {
    return () => {
      setPollItems(['', '', '']);
    };
  }, [visible]);

  useEffect(() => {
    if (formType === '  edit') {
      form.setFieldsValue({
        text: editData?.text,
        image: editData?.image,
      });
    }

    return () => {
      dispatch(clearHelperState());
    };
  }, [dispatch, editData?.image, editData?.text, form, formType]);

  const [pollError, setPollError] = useState(false);
  const [pollLengthError, setPollLengthError] = useState(false);

  const user = useSelector((state: any) => state?.auth?.creds?.user_data);
  const websiteInfo = useSelector((state: any) => state?.helperReducer?.websiteInfo);

  const getSrcFromFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
    });
  };

  const onPreview = async (file) => {
    const src = file.url || (await getSrcFromFile(file));
    const imgWindow = window.open(src);

    if (imgWindow) {
      const image = new Image();
      image.src = src;
      imgWindow.document.write(image.outerHTML);
    } else {
      window.location.href = src;
    }
  };

  const onTextChange = (e) => {
    setPostData(e.target.value.trim());
    const links = isLinkPresent(e.target.value.trim());

    if (links !== null && links.length !== 0) {
      if (websiteInfo?.data?.url !== links[0]) {
        dispatch(getWebsiteInfo({ link: links[0] }));
      }
    }
  };

  const onFileChange = (e) => {
    if (postFile === null) {
      setPostFile(e.target.files[0]);
      // setPostFile(e.file.originFileObj);
    }
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  const onRemove = (file) => {
    setPostFile(null);
  };

  const handleOpenAddPoll = () => {
    setCreatePoll(true);
  };

  const handleCloseAddPoll = () => {
    setCreatePostPoll(false);
    setCreatePoll(false);
  };

  const onAdd = (values) => {
    const pollDatas = pollItems?.filter((el) => {
      if (el !== '') return el;
    });

    const pollValues = {
      text: values?.text,
      room: roomId,
      answer: pollDatas?.length && pollDatas,
      is_poll: true,
    };

    values = {
      ...values,
      room: roomId,
      is_poll: false,
    };
    let value;
    if (postFile && isPostImage) {
      value = FormDataHelper(values, {
        image: postFile,
      });
    } else {
      let imgRemoval = removeImageKeyFromObj(values, 'image');
      value = FormDataHelper(imgRemoval, {});
    }

    const isPoll = pollDatas.every((el) => el !== '');

    isPoll && pollDatas?.length > 1
      ? dispatch(addRoomDiscussion({ data: pollValues }))
      : dispatch(addRoomDiscussion({ data: value }));
  };

  const onEdit = (values) => {
    values = {
      ...values,
      room: roomId,
    };
    let value;
    if (postFile && isPostImage) {
      value = FormDataHelper(values, { image: postFile });
    } else {
      let imgRemoval = removeImageKeyFromObj(values, 'image');
      value = FormDataHelper(imgRemoval, {});
    }
    dispatch(editRoomDiscussion({ data: value, discussionId }));
  };

  return (
    <div className="discussion-modal">
      <Modal
        visible={visible}
        title={title}
        centered={windowSize.current > 1400}
        destroyOnClose
        onCancel={() => {
          setCreatePostPoll(false);
          setIsPostImage(false);
          onCancel();
        }}
        maskClosable={false}
        footer={[
          <div className="d-flex flex-column " key="footer">
            <div className="w-100 h-100">
              <Button
                loading={loading}
                className={`w-100 h-100 button-hover-border p-2 border-0  ${
                  postData && !pollError
                    ? 'cursor-pointer btn-primary'
                    : ' cursor-disabled'
                }`}
                onClick={() => {
                  postData?.length > 0 &&
                    !pollError &&
                    !pollLengthError &&
                    form
                      .validateFields()
                      .then((values) => {
                        editData ? onEdit(values) : onAdd(values);
                        setTimeout(() => {
                          createPostPoll && setCreatePostPoll(false);
                          isPostImage && setIsPostImage(false);
                        }, 3000);
                        setTimeout(() => {
                          setPostData('');
                        }, 5000);
                      })
                      .catch((err) => {
                        // console.log(err);
                      });
                }}
                htmlType="submit"
                key="1"
                style={{
                  fontSize: '17px',
                  borderRadius: '8px',
                  background: '#E4E6EB',
                }}
              >
                Post
              </Button>
            </div>
            {postData?.length === 0 && !pollError && createPostPoll && (
              <span className="text-danger w-100 mt-1" style={{ textAlign: 'left' }}>
                You can't create a poll without text in your post.
              </span>
            )}
            {pollError && createPostPoll && (
              <span className="text-danger w-100 mt-1" style={{ textAlign: 'left' }}>
                You cannot post duplicated poll items.
              </span>
            )}
            {pollLengthError && (
              <span className="text-danger w-100 mt-1" style={{ textAlign: 'left' }}>
                Need minimum two options to create poll.
              </span>
            )}
          </div>,
        ]}
      >
        <div className="add-modal-selector">
          <div className="d-flex align-items-center gap-2 mb-2">
            <AvatarComponent
              firstName={user?.first_name}
              lastName={user?.last_name}
              avatar={user?.avatar}
              size={40}
            />
            <div className="d-flex flex-column ">
              <span
                className="text-black"
                style={{ fontWeight: '600', fontSize: '0.875rem' }}
              >
                {`${capitalizeFirstLetter(user?.first_name)} ${user?.last_name}`}
              </span>
              <div
                className="d-flex align-items-center px-2 gap-2"
                style={{ background: '#E4E6EB', borderRadius: '5px' }}
              >
                <i className="fas fa-users"></i>
                <div>
                  <span
                    className="font-weight-bold text-muted text-truncate"
                    style={{
                      fontSize: '10px',
                      width: '80px',
                    }}
                  >
                    {roomTitle}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <Form
            form={form}
            initialValues={{ text: editData?.text, image: editData?.image }}
          >
            <Form.Item name="text">
              <CustomDiscussionTextArea
                defaultValue={formType === 'edit' ? editData?.text : ''}
                placeholder={'Write Something . . .'}
                onChange={onTextChange}
                visible={visible}
              >
                {websiteInfo?.getWebsiteInfoStatus === 'request' ? (
                  <LinkPreviewLoader />
                ) : (
                  !isObjEmpty(websiteInfo?.data) && (
                    <NewLinkPreview website_info={websiteInfo?.data} closable />
                  )
                )}
              </CustomDiscussionTextArea>
            </Form.Item>
            {isPostImage && (
              <Form.Item className="m-0">
                <Form.Item name="image" getValueFromEvent={onFileChange}>
                  <div
                    className="position-relative border p-1"
                    style={{ borderRadius: '8px' }}
                  >
                    <CloseOutlined
                      rev=""
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsPostImage(false);
                      }}
                      className="hover-icon-bg p-2 position-absolute "
                      style={{ right: 0, zIndex: '200' }}
                    />
                    <Upload
                      listType="picture"
                      className="mt-1 m-1 d-flex flex-column border-0  justify-content-center upload-list-inline  h-100"
                      maxCount={1}
                      onPreview={onPreview}
                      onRemove={onRemove}
                    >
                      <Button
                        className="border-0 w-100 h-100 py-5 button-hover-border"
                        style={{
                          fontSize: '16px',
                          borderRadius: '8px',
                          background: 'rgb(228, 230, 235)',
                        }}
                      >
                        <i className="fas fa-images mr-1"></i>
                        Add Photos
                      </Button>
                    </Upload>
                  </div>
                </Form.Item>
              </Form.Item>
            )}
            {(createPoll || createPostPoll) && (
              <DiscussionPoll
                onClose={handleCloseAddPoll}
                pollItems={pollItems}
                setPollItems={setPollItems}
                error={pollError}
                setError={setPollError}
                setLengthError={setPollLengthError}
              />
            )}
          </Form>
        </div>
      </Modal>
    </div>
  );
};

export default DiscussionModal;
